import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import {
  Building2,
  MessageSquare,
  ListChecks,
  Route as RouteIcon,
  Archive,
  Settings as SettingsIcon,
  Sparkles,
} from "lucide-react";
import { cn } from "@/lib/utils";
import RunwayWidget from "./RunwayWidget";

const NAV = [
  { to: "/boardroom", label: "Boardroom", icon: Building2, testId: "nav-boardroom" },
  { to: "/agents", label: "Agents", icon: MessageSquare, testId: "nav-agents" },
  { to: "/tasks", label: "Tasks", icon: ListChecks, testId: "nav-tasks" },
  { to: "/roadmap", label: "Roadmap", icon: RouteIcon, testId: "nav-roadmap" },
  { to: "/vault", label: "Venture Vault", icon: Archive, testId: "nav-vault" },
  { to: "/settings", label: "Settings", icon: SettingsIcon, testId: "nav-settings" },
];

export default function Sidebar({ onNavigate }) {
  return (
    <aside
      data-testid="sidebar"
      className="flex h-full w-[280px] flex-shrink-0 flex-col border-r border-black/[0.04] bg-[#FBFBFA] md:w-[232px]"
    >
      {/* Brand */}
      <div className="px-5 pb-5 pt-6">
        <Link
          to="/"
          data-testid="sidebar-brand-link"
          onClick={onNavigate}
          className="group flex items-center gap-3 rounded-lg outline-none focus-visible:ring-2 focus-visible:ring-violet-400"
        >
          <div
            data-testid="brand-logo"
            className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-zinc-900 to-black shadow-sm transition-transform group-hover:scale-105"
          >
            <Sparkles className="h-4 w-4 text-white" strokeWidth={2.4} />
          </div>
          <div className="leading-tight">
            <div className="text-[15px] font-extrabold tracking-tight text-zinc-900">
              Idea AI
            </div>
            <div className="eyebrow mt-0.5 text-[9px] tracking-[0.18em]">
              Boardroom v1
            </div>
          </div>
        </Link>
      </div>

      {/* Workspace */}
      <div className="px-3 pb-2">
        <div className="eyebrow mb-2 px-3">Workspace</div>
        <nav className="flex flex-col gap-1">
          {NAV.map(({ to, label, icon: Icon, testId }) => (
            <NavLink
              key={to}
              to={to}
              data-testid={testId}
              onClick={onNavigate}
              className={({ isActive }) =>
                cn(
                  "group flex min-h-[44px] items-center gap-3 rounded-full px-3 py-2.5 text-[14px] font-medium transition-all",
                  isActive
                    ? "bg-black text-white shadow-sm"
                    : "text-zinc-600 hover:bg-black/[0.04] hover:text-zinc-900",
                )
              }
            >
              {({ isActive }) => (
                <>
                  <Icon
                    className={cn(
                      "h-[18px] w-[18px] shrink-0 transition-colors",
                      isActive ? "text-white" : "text-zinc-500 group-hover:text-zinc-800",
                    )}
                    strokeWidth={2}
                  />
                  <span className="truncate">{label}</span>
                </>
              )}
            </NavLink>
          ))}
        </nav>
      </div>

      {/* Spacer */}
      <div className="flex-1" />

      {/* Runway */}
      <div className="px-3 pb-4">
        <RunwayWidget />
      </div>
    </aside>
  );
}
